<template>
  <v-dialog v-model="isOpen"
    persistent
    scrollable
    content-class="user-pref-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          :src="require('../../assets/' + coloredLogo)" />
        <span class="modal-title">{{modalTitle}}</span>
        <v-spacer />
        <v-btn text @click="clearDataAndClose()">
          <v-avatar size="20" class="mr-2">
            <img :src="require('../../assets/' + coloredAssetUrls.close)" />
          </v-avatar>Close
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid grid-list-md>
          <v-layout wrap>
            <v-flex md12>
              <div class="error">{{error}}</div>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">ID*</label>
              </div>
              <v-text-field class="inputField"
                type="text"
                name="user.id"
                v-model="user.id"
                v-validate="{ required: true }"
                autocomplete="off"
                :disabled="isEDSADUser"
                solo />
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Password</label>
              </div>
              <v-text-field
                :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                class="inputField"
                :type="showPassword ? 'text' : 'password'"
                name="user.password"
                v-model="user.password"
                v-validate="{ required: isEditingPassword, regex: this.regex }"
                autocomplete="off"
                :disabled="isEDSADUser"
                @click:append="showPassword = !showPassword"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Confirm Password</label>
              </div>
              <v-text-field
                :append-icon="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"
                class="inputField"
                :type="showConfirmPassword ? 'text' : 'password'"
                name="user.confirmPass"
                v-model="confirmPass"
                v-validate="{ required: isEditingPassword, regex: this.regex }"
                autocomplete="off"
                :disabled="isEDSADUser"
                @click:append="showConfirmPassword = !showConfirmPassword"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">First Name*</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="user.fName"
                v-model="user.fName"
                v-validate="{ required: true }"
                autocomplete="off"
                :disabled="isEDSADUser"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Last Name*</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="user.lName"
                v-model="user.lName"
                v-validate="{ required: true }"
                autocomplete="off"
                :disabled="isEDSADUser"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Status*</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="user.isActive"
                :items="USER_STATUS"
                name="user.isActive"
                :disabled="isEDSADUser"
                v-validate="{ required: true }"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Roles*</label>
              </div>
              <select-with-button
                class="inputField"
                v-model="user.desig"
                :items="this.desigvalues"
                name="user.desig"
                :disabled="isEDSADUser"
                v-validate="{ required: true }"/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Contact No.</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="user.contactNumber"
                v-model="user.contactNumber"
                :disabled="isEDSADUser"
                solo/>
            </v-flex>
            <v-flex md3>
              <div>
                <label class="modal-label">Email</label>
              </div>
              <v-text-field
                class="inputField"
                type="text"
                name="user.email"
                v-model="user.email"
                :disabled="isEDSADUser"
                solo/>
            </v-flex>
            <v-flex md3>
              <v-checkbox     
                :color="colorHex"
                v-model="user.changePWD" 
                :disabled="isEDSADUser"
                :label="`User Can Change Password`"></v-checkbox>
            </v-flex>
            <v-flex md3>
              <v-checkbox    
                :color="colorHex"
                v-model="user.changePWDMust"
                :disabled="isEDSADUser"
                :label="`User Must Change Password Next Login`"></v-checkbox>
            </v-flex>
            <v-flex md3>
              <v-checkbox    
                :color="colorHex"
                v-model="user.userPrefMenu"
                :label="`Hide User Preferences Menu`"></v-checkbox>
              <span>(Please note that the change will go into effect upon user's next login)</span>
            </v-flex>
            <v-flex md9>
              <div>
                <label class="modal-label">Practice Group(s)</label>
              </div>
              <select-with-button
                multiple
                class="inputField"
                v-model="user.practiceGroupId"
                :items="this.practiceGroupDropDown"
                name="user.practiceGroupId"/>
            </v-flex>
            <v-flex md3>
              <span>Passwords must be at least 8 characters in length and contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 of the following symbols !@#$%^&*</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="clearDataAndClose()" class="modal-cta">Cancel</v-btn>
        <v-btn text @click="submit" class="modal-cta">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  CHNG_PSWD,
  USER_STATUS,
  USER_DESIGN_ADD,
} from "../../config/config.js";
import selectWithButton from "../../components/controls/SelectWithButton";
import { mapGetters } from "vuex";

export default {
  name: "addUser",
  components: {
    selectWithButton
  },
  props: {
    isOpen: Boolean,
    isUpdate: Boolean,
    user: Object,
    isEDSADUser: Boolean
  },
  data() {
    return { 
      CHNG_PSWD: CHNG_PSWD,
      USER_DESIGN: USER_DESIGN_ADD.slice(),
      USER_STATUS: USER_STATUS,
      confirmPass: "",
      error: null,
      regex: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/),
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    ...mapGetters(["practiceGroupsList", "userPracticeGroupIds", "userList"]),
    modalTitle() {
      return (this.isUpdate ? "Update User" : "Add User");
    },
    isEditingPassword() {
      if (this.user.password !== "" && this.confirmPass !== "")
        return true;
      return false;
    },
    practiceGroupDropDown(){
      let list = [];
      this.practiceGroupsList.forEach(e => {
        let item = {value: e.practiceGroupId, text: e.name, disabled: this.isDisabled(e.practiceGroupId)};
        list.push(item); 
      });

      return list;
    },
    desigvalues(){
      let result = this.USER_DESIGN;
      let val = this.user.desig;

      if(result.find(item => item.value == val) == null){
        result.push({value: val, text: val});
      }
      result = result.filter(e =>e.text != null);

      return result;
    }
  },
  methods: {
    isDisabled(practiceGroupId){
        return !this.userPracticeGroupIds.includes(practiceGroupId);
    },
    clearDataAndClose(){
      this.confirmPass = "";
      this.error = null;
      this.USER_DESIGN = USER_DESIGN_ADD.slice();
      this.$emit("close");
    },
    submit() {
      this.$validator.validateAll()
        .then(valid => {
                  
          let duplicateId = false;
          this.userList.forEach(u => {
            if (this.user.id !== null && u.id.toLowerCase() == this.user.id.toLowerCase())
              duplicateId = true;
          });
          if (duplicateId && !this.isUpdate)
              this.error = "User ID already exists. Please use another."
          else if (valid) { 
            if (!this.regex.exec(this.user.password) && !this.isUpdate)
              this.error = "The passwords do not fulfill the minimum password strength requirements. Password must contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol. They must also be at least 8 characters in length.";
            else if (this.user.password == this.confirmPass) {
              this.$emit("submit", this.user);
              this.confirmPass = "";
              this.error = null;
              this.$store.commit("displayStatus", { message: "Success! ", level: "success" });
            } 
            else 
              this.error = "The passwords do not match.";
          }
          else {
            if (!this.regex.exec(this.user.password))
              this.error = "The passwords do not fulfill the minimum password strength requirements. Password must contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol. They must also be at least 8 characters in length.";
            else
              this.error = "Please input all required fields.";
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-axis-logo {
  width: 60px;
}

.inputField {
  max-width: 400px;
}

.error{
  text-align: center;
}
</style>